import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowsSwap = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20.9464 5.71587L20.2481 5L18.8164 6.39647L19.5146 7.11234L31.0092 18.8972H8.78646L14.2035 13.3433L14.9018 12.6275L13.47 11.231L12.7718 11.9469L5.70782 19.1893L5 19.8796L5.01722 19.8973L5 19.915L5.70781 20.6053L12.7718 27.8477L13.47 28.5636L14.9018 27.1671L14.2035 26.4513L8.78632 20.8972H31.0092L19.5146 32.6821L18.8164 33.398L20.2481 34.7945L20.9464 34.0786L34.0881 20.6049L34.7956 19.9149L34.7784 19.8972L34.7956 19.8796L34.0879 19.1893L20.9464 5.71587Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgArrowsSwap);
export default ForwardRef;
